import { render } from "./DocumentosPage.vue?vue&type=template&id=1bd7b904"
import script from "./DocumentosPage.vue?vue&type=script&lang=js"
export * from "./DocumentosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__